import { bindRequestLogic } from './utils'
import Types from '../actionTypes/partnerAPIKey'
import { partnerAPIKeyAPI } from '../api'

const getPartnerAPIKeys = bindRequestLogic({
  clientFunc: partnerAPIKeyAPI.getPartnerAPIKeys,
  type: Types.GET_PARTNER_API_KEYS_REQUEST,
  successType: Types.GET_PARTNER_API_KEYS_SUCCESS,
  failType: Types.GET_PARTNER_API_KEYS_FAILED,
  isQueryParam: true
})

const addPartnerAPIKey = bindRequestLogic({
  clientFunc: partnerAPIKeyAPI.addPartnerAPIKey,
  type: Types.ADD_PARTNER_API_KEY_REQUEST,
  successType: Types.ADD_PARTNER_API_KEY_SUCCESS,
  failType: Types.ADD_PARTNER_API_KEY_FAILED
})

const getPartnerAPIKeyDetail = bindRequestLogic({
  clientFunc: partnerAPIKeyAPI.getPartnerAPIKey,
  type: Types.GET_PARTNER_API_KEY_DETAIL_REQUEST,
  successType: Types.GET_PARTNER_API_KEY_DETAIL_SUCCESS,
  failType: Types.GET_PARTNER_API_KEY_DETAIL_FAILED
})

const updatePartnerAPIKey = bindRequestLogic({
  clientFunc: partnerAPIKeyAPI.updatePartnerAPIKey,
  type: Types.UPDATE_PARTNER_API_KEY_REQUEST,
  successType: Types.UPDATE_PARTNER_API_KEY_SUCCESS,
  failType: Types.UPDATE_PARTNER_API_KEY_FAILED
})

const deletePartnerAPIKey = bindRequestLogic({
  clientFunc: partnerAPIKeyAPI.deletePartnerAPIKey,
  type: Types.DELETE_PARTNER_API_KEY_REQUEST,
  successType: Types.DELETE_PARTNER_API_KEY_SUCCESS,
  failType: Types.DELETE_PARTNER_API_KEY_FAILED
})

const regeneratePartnerAPIKey = bindRequestLogic({
  clientFunc: partnerAPIKeyAPI.regeneratePartnerAPIKey,
  type: Types.REGENERATE_PARTNER_API_KEY_REQUEST,
  successType: Types.REGENERATE_PARTNER_API_KEY_SUCCESS,
  failType: Types.REGENERATE_PARTNER_API_KEY_FAILED
})

const getLogsPartnerAPIKey = bindRequestLogic({
  clientFunc: partnerAPIKeyAPI.getLogsPartnerAPIKey,
  type: Types.GET_LOGS_PARTNER_API_KEY_REQUEST,
  successType: Types.GET_LOGS_PARTNER_API_KEY_SUCCESS,
  failType: Types.GET_LOGS_PARTNER_API_KEY_FAILED,
  isQueryParam: true
})

const addPeriodPartnerAPIKey = bindRequestLogic({
  clientFunc: partnerAPIKeyAPI.addPeriodPartnerAPIKey,
  type: Types.ADD_PERIOD_PARTNER_API_KEY_REQUEST,
  successType: Types.ADD_PERIOD_PARTNER_API_KEY_SUCCESS,
  failType: Types.ADD_PERIOD_PARTNER_API_KEY_FAILED
})

const updatePeriodPartnerAPIKey = bindRequestLogic({
  clientFunc: partnerAPIKeyAPI.updatePeriodPartnerAPIKey,
  type: Types.UPDATE_PERIOD_PARTNER_API_KEY_REQUEST,
  successType: Types.UPDATE_PERIOD_PARTNER_API_KEY_SUCCESS,
  failType: Types.UPDATE_PERIOD_PARTNER_API_KEY_FAILED
})

const deletePeriodPartnerAPIKey = bindRequestLogic({
  clientFunc: partnerAPIKeyAPI.deletePeriodPartnerAPIKey,
  type: Types.DELETE_PERIOD_PARTNER_API_KEY_REQUEST,
  successType: Types.DELETE_PERIOD_PARTNER_API_KEY_SUCCESS,
  failType: Types.DELETE_PERIOD_PARTNER_API_KEY_FAILED
})

export default [
  getPartnerAPIKeys,
  addPartnerAPIKey,
  getPartnerAPIKeyDetail,
  updatePartnerAPIKey,
  deletePartnerAPIKey,
  regeneratePartnerAPIKey,
  getLogsPartnerAPIKey,
  addPeriodPartnerAPIKey,
  updatePeriodPartnerAPIKey,
  deletePeriodPartnerAPIKey
]
